import { twMerge } from 'tailwind-merge';
import { ISocialIconProps } from '../SocialLinks';

export interface SocialLinkProps {
  to: string;
  icon: React.ComponentType<ISocialIconProps>;
  onClick?: React.MouseEventHandler;
  className?: string;
}

export const SocialLink = ({ to, icon: Icon, onClick, className }: SocialLinkProps) => {
  return (
    <a
      onClick={onClick}
      href={to}
      target="_blank"
      className={twMerge(
        `flex items-center align-middle text-white opacity-80 transition-all duration-300 ease-in-out hover:text-white
        hover:opacity-100`,
        className,
      )}
    >
      <Icon className="h-6 w-6 lg:h-9 lg:w-9" />
    </a>
  );
};
